import { FC, Fragment } from 'react';

import {
  type SearchParamsPetCounts,
  SearchParamsPetType,
} from '@rover/constants/src/translations/sitterProfilePage.constants';
import { ShimmerRegion } from '@rover/kibble/patterns/ShimmerRegion';
import type { EnhancedPersonSitterProfileService } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileService';

import { selectPrimaryPetRate, usePrimaryPetType } from '../../utils/utils';

import AcceptingNewCustomersLabel from './AcceptingNewCustomersLabel';
import Separator from './Separator';
import ServiceHeader from './ServiceHeader';
import ServiceHeaderLoadingShimmer from './ServiceHeaderLoadingShimmer';

export type ServiceSectionItemProps = {
  index: number;
  service: EnhancedPersonSitterProfileService;
  petType?: SearchParamsPetType;
  petCounts: SearchParamsPetCounts;
  isRequoting?: boolean;
  showSittersRates?: boolean;
};

const ServiceSectionItem: FC<ServiceSectionItemProps> = ({
  index,
  service,
  petType,
  petCounts,
  isRequoting = false,
  showSittersRates = true,
}) => {
  const primaryPetType = usePrimaryPetType(petCounts, petType, [service]);
  const rateData = selectPrimaryPetRate(service, primaryPetType, petCounts);

  return (
    <Fragment>
      <Separator withBorder={index !== 0} />
      <ShimmerRegion
        isLoading={isRequoting}
        webProps={{ 'aria-label': service.displayName }}
        shimmer={<ServiceHeaderLoadingShimmer />}
        content={
          <>
            <ServiceHeader
              service={service}
              standardRate={rateData}
              priceInCredits={rateData?.priceInCredits}
              showSittersRates={showSittersRates}
            />
            <AcceptingNewCustomersLabel service={service} />
          </>
        }
      />
    </Fragment>
  );
};

export default ServiceSectionItem;
